import { Button } from "@mantine/core";
import { IIssueBoardApi } from "@schemas/issueBoardSchema";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FailedAlert, McInput, MCLoader, McTitle } from "../../../../components";
import { getProjectIdFromUrl } from "../../../utils";
import { useMoveIssueBoardToOtherProjectMutation } from "../IssueBoardRTK";
import SettingsCardWrapper from "./SettingsCardWrapper";

const MoveIssueBoardToOtherProject: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const [projectNo, setProjectNo] = React.useState<number>();

  const history = useHistory();
  const projectId = getProjectIdFromUrl(history.location.pathname);

  const isProjectValid = howManyCharsIsNumber(projectNo) === 8 || projectNo === 100;

  const [moveIssueBoardToOtherProject, { isError, isLoading, isSuccess }] = useMoveIssueBoardToOtherProjectMutation();

  useEffect(() => {
    if (isSuccess === true) {
      history.push(`/project/${projectId}/issues`);
    }
  }, [isSuccess]);

  return (
    <SettingsCardWrapper title={"Flytt register til et annet prosjekt"}>
      {isError && <FailedAlert />}
      {isLoading && <MCLoader />}
      <McTitle style={{ width: "200px" }} title="Oppdragsnummer">
        <McInput
          title="Oppdragsnummer"
          type="number"
          value={projectNo}
          onChange={(e) => setProjectNo(Number(e.target.value))}
        />
      </McTitle>
      <Button
        w={"fit-content"}
        mt={"xs"}
        px={"sm"}
        color={!isProjectValid || isLoading ? "lightgray.6" : "green.5"}
        disabled={!isProjectValid || isLoading}
        onClick={() =>
          moveIssueBoardToOtherProject({
            maconomyProjectNo: projectNo,
            issueBoardId: issueBoard._id,
            projectId: issueBoard.project,
          })
        }
      >
        <i className="fa fa-arrow-right fa-fw mr-1" />
        Flytt register
      </Button>
    </SettingsCardWrapper>
  );
};

export default MoveIssueBoardToOtherProject;

const howManyCharsIsNumber = (num: number | null): number => {
  return num?.toString().length ?? 0;
};
